import * as React from "react";
import asCard, { CardProps } from "./Card";
import { DynamicTypography, DynamicTypographyType } from "../../core/utils/DynamicTypography";
import { Fonts } from "../../core/utils/Fonts";
import { Colors } from "../../core/utils/Colors";

export interface TextCardProps extends CardProps {
    text: string;
    textType?: DynamicTypographyType;
}

export class ImageCard extends React.Component<TextCardProps> {
    render() {
        let textType = this.props.textType ? this.props.textType : DynamicTypographyType.H1;
        if (this.props.height) {
            return (
                <DynamicTypography
                    variant={textType}
                    style={{ padding: 10, color: Colors.black, fontFamily: Fonts.BalsamiqSans }}
                >
                    {this.props.text}
                </DynamicTypography>
            );
        } else {
            return <div style={{ opacity: 0, height: this.props.maxHeight * 0.8 }} />;
        }
    }
}

export default asCard(ImageCard);
